// ===============================
// Cart Drawer + Discount (Full JS)
// ===============================
// English comments as requested

// ---------- DISCOUNT ----------
async function applyDiscount(code) {
  const btn = document.getElementById('ApplyDiscountBtn');
  const spinner = btn?.querySelector('.spinner');
  const msg = document.getElementById('DiscountMessage');

  if (!btn || !msg) return;

  btn.disabled = true;
  spinner && spinner.classList.remove('hidden');
  msg.textContent = '';
  msg.className = 'discount-message';

  try {
    await fetch(`/discount/${encodeURIComponent(code)}`, {
      method: 'GET',
      credentials: 'same-origin',
    });

    const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
    const cart = await cartRes.json();

    const hasDiscount =
      Array.isArray(cart.cart_level_discount_applications) &&
      cart.cart_level_discount_applications.length > 0;

    if (hasDiscount) {
      await refreshDrawerFooter();

      // Re-apply Klarna + Sufio visibility after footer replacement
      const drawer = document.querySelector('#CartDrawer') || document;
      updateKlarnaVisibility(cart.total_price, drawer);
      applySufioEuVisibility(drawer, cart.item_count);

      msg.textContent = 'Discount applied!';
      msg.classList.add('success');
    } else {
      msg.textContent = 'Invalid discount code.';
      msg.classList.add('error');
    }
  } catch (err) {
    console.error(err);
    msg.textContent = 'Something went wrong.';
    msg.classList.add('error');
  }

  btn.disabled = false;
  spinner && spinner.classList.add('hidden');
}

// ---------- KLARNA (show ONLY when cart total < 2000 EUR) ----------
// Shopify cart.total_price is minor units (e.g. 64475 -> 644.75).
const KLARNA_MAX_TOTAL_MAJOR = 2000;

function getKlarnaNodes(scope = document) {
  const nodes = [];
  scope.querySelectorAll('klarna-placement').forEach((n) => nodes.push(n));
  scope.querySelectorAll('[data-klarna], [data-klarna-container], .klarna-placement').forEach((n) => nodes.push(n));
  return Array.from(new Set(nodes));
}

function refreshKlarnaPlacements() {
  try {
    window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
    window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
  } catch (e) {
    // no-op
  }
}

function updateKlarnaVisibility(totalPriceMinor, scope = document) {
  const totalMajor = (Number(totalPriceMinor) || 0) / 100;
  const shouldShow = totalMajor < KLARNA_MAX_TOTAL_MAJOR;

  const nodes = getKlarnaNodes(scope);
  if (!nodes.length) return;

  nodes.forEach((n) => {
    n.style.display = shouldShow ? '' : 'none';
  });

  // If showing, force Klarna to re-render placements
  if (shouldShow) refreshKlarnaPlacements();
}

// ---------- SUFIO EU (EU except ES, ONLY when customer) ----------
const EU_COUNTRIES_EXCEPT_ES = [
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR',
  'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'SE',
];

function getCustomerCountryCode() {
  // Must be injected by Liquid if customer is logged in:
  // window.__CUSTOMER_COUNTRY__ = "{{ customer.default_address.country_code }}";
  const cc = (window.__CUSTOMER_COUNTRY__ || '').toString().toUpperCase();
  return cc || '';
}

function isCustomerEUExceptES() {
  const cc = getCustomerCountryCode();
  if (!cc) return false; // Not a customer (or no default address injected)
  return EU_COUNTRIES_EXCEPT_ES.includes(cc);
}

function applySufioEuVisibility(scope = document, itemCount = null) {
  const forms = scope.querySelectorAll('.sufio-vat-form.sufio-vat-cart-form');
  if (!forms.length) return;

  // Only show for EU (except ES) AND only when customer exists
  const shouldShow = isCustomerEUExceptES();

  forms.forEach((el) => {
    el.hidden = !shouldShow;
    el.style.display = shouldShow ? '' : 'none';
    if (!shouldShow) el.classList.remove('active');
  });

  // If cart empty -> always hide (VAT form in footer should not show)
  if (itemCount === 0) {
    forms.forEach((el) => {
      el.hidden = true;
      el.style.display = 'none';
      el.classList.remove('active');
    });
    return;
  }
}

// ---------- FOOTER REFRESH ----------
async function refreshDrawerFooter() {
  try {
    const url = `/cart?t=${Date.now()}`;
    const res = await fetch(url, {
      credentials: 'same-origin',
      method: 'GET',
    });

    const cartHTML = await res.text();
    const html = document.createElement('div');
    html.innerHTML = cartHTML;

    const newFooter = html.querySelector('.drawer__footer');
    const currentFooter = document.querySelector('#CartDrawer .drawer__footer');

    if (newFooter && currentFooter) {
      currentFooter.replaceWith(newFooter);

      // After footer DOM is replaced, re-sync using latest cart state
      try {
        const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
        const cart = await cartRes.json();

        const drawer = document.querySelector('#CartDrawer') || document;
        updateKlarnaVisibility(cart.total_price, drawer);
        applySufioEuVisibility(drawer, cart.item_count);
      } catch (e) {
        console.error(e);
      }

      refreshKlarnaPlacements();
    } else {
      console.warn('Footer elements not found.', { newFooter: !!newFooter, currentFooter: !!currentFooter });
    }
  } catch (err) {
    console.error('Error refreshing drawer footer:', err);
  }
}

// ---------- CART DRAWER (remove + quantity + rebuild on add) ----------
(() => {
  const DRAWER_SELECTOR = '#CartDrawer';
  const MAIN_CART_SECTION_ID = 'main-cart';

  function getRootPath() {
    return window.Shopify?.routes?.root || '/';
  }

  function getDrawer() {
    return document.querySelector(DRAWER_SELECTOR);
  }

  function setDrawerEmptyState(drawerEl, isEmpty) {
    const inner = drawerEl.querySelector('.drawer__inner');
    const empty = drawerEl.querySelector('.drawer__cart-empty');
    const footer = drawerEl.querySelector('.drawer__footer');

    if (inner) inner.style.display = isEmpty ? 'none' : '';
    if (footer) footer.style.display = isEmpty ? 'none' : '';
    if (empty) empty.style.display = isEmpty ? '' : 'none';
  }

  async function cartChange(key, quantity) {
    const res = await fetch(`${getRootPath()}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity }),
    });

    if (!res.ok) {
      const msg = await res.text().catch(() => '');
      throw new Error(`cart/change.js failed: ${res.status} ${msg}`);
    }

    return res.json(); // updated cart object
  }

  const NOTE_MAX_LENGTH = 200;
  let noteDebounceTimer = null;

  function normalizeCartNote(note) {
    if (typeof note !== 'string') {
      note = note == null ? '' : String(note);
    }

    return note.trim();
  }

  async function updateCartNote(note) {
    const res = await fetch(`${getRootPath()}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ note: normalizeCartNote(note) }),
    });

    if (!res.ok) {
      const msg = await res.text().catch(() => '');
      throw new Error(`cart/update.js note failed: ${res.status} ${msg}`);
    }

    return res.json();
  }

  function updateNoteCount(input) {
    const wrapper = input.closest('[data-cart-note-wrapper]');
    const count = wrapper?.querySelector('[data-cart-note-count]');
    if (!count) return;

    count.textContent = String(input.value.length);
  }

  function setCartNoteOpen(wrapper, isOpen, focusInput = false) {
    const toggle = wrapper.querySelector('[data-cart-note-toggle]');
    const toggleText = wrapper.querySelector('[data-cart-note-toggle-text]');
    const panel = wrapper.querySelector('[data-cart-note-panel]');
    const input = wrapper.querySelector('[data-cart-note-input]');

    wrapper.classList.toggle('is-open', isOpen);
    if (toggle) toggle.setAttribute('aria-expanded', String(isOpen));
    if (toggleText) toggleText.textContent = isOpen ? 'Hide order notes' : 'Add order notes';
    if (panel) panel.hidden = !isOpen;

    if (isOpen && focusInput && input) {
      window.requestAnimationFrame(() => input.focus());
    }
  }

  function scheduleCartNoteSave(input) {
    clearTimeout(noteDebounceTimer);
    noteDebounceTimer = setTimeout(() => {
      updateCartNote(input.value).catch(console.error);
    }, 500);
  }

  function onCartNoteToggleClick(e) {
    const toggle = e.target.closest('[data-cart-note-toggle]');
    if (!toggle || !toggle.closest(DRAWER_SELECTOR)) return;

    e.preventDefault();

    const wrapper = toggle.closest('[data-cart-note-wrapper]');
    if (!wrapper) return;

    setCartNoteOpen(wrapper, !wrapper.classList.contains('is-open'), true);
  }

  function onCartNoteInput(e) {
    const input = e.target.closest('[data-cart-note-input]');
    if (!input || !input.closest(DRAWER_SELECTOR)) return;

    if (input.value.length > NOTE_MAX_LENGTH) {
      input.value = input.value.slice(0, NOTE_MAX_LENGTH);
    }

    updateNoteCount(input);
    scheduleCartNoteSave(input);
  }

  function onCartNoteChange(e) {
    const input = e.target.closest('[data-cart-note-input]');
    if (!input || !input.closest(DRAWER_SELECTOR)) return;

    clearTimeout(noteDebounceTimer);
    updateNoteCount(input);
    updateCartNote(input.value).catch(console.error);
  }

  async function fetchSectionHTML(sectionId) {
    const url = new URL(`${getRootPath()}?sections=${encodeURIComponent(sectionId)}`, window.location.origin);

    const res = await fetch(url.toString(), {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });

    if (!res.ok) {
      const msg = await res.text().catch(() => '');
      throw new Error(`sections fetch failed: ${res.status} ${msg}`);
    }

    const raw = await res.text();
    const json = JSON.parse(raw);
    return json[sectionId] || Object.values(json)[0] || '';
  }

  async function refreshHeaderCartIcon() {
    const HEADER_SECTION_ID = 'header';

    const url = new URL(`/?sections=${encodeURIComponent(HEADER_SECTION_ID)}`, window.location.origin);
    const res = await fetch(url.toString(), { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!res.ok) return;

    const raw = await res.text();
    let html = '';
    try {
      const json = JSON.parse(raw);
      html = json[HEADER_SECTION_ID] || Object.values(json)[0] || '';
    } catch {
      html = raw;
    }

    const doc = new DOMParser().parseFromString(html, 'text/html');

    const newIcon = doc.querySelector('a.site-nav__link--icon.js-drawer-open-cart');
    const curIcon = document.querySelector('a.site-nav__link--icon.js-drawer-open-cart');

    if (newIcon && curIcon) {
      curIcon.replaceWith(newIcon);
    }
  }

  async function refreshDrawerFromMainCart(updatedCart) {
    const drawer = getDrawer();
    if (!drawer) return;

    let cart = updatedCart;
    if (!cart) {
      const cartRes = await fetch(`${getRootPath()}cart.js`, { credentials: 'same-origin' });
      cart = await cartRes.json();
    }

    // Update count
    const countEl = drawer.querySelector('[data-cart-count]');
    if (countEl) countEl.textContent = String(cart.item_count);

    // Empty state (also hides footer)
    setDrawerEmptyState(drawer, cart.item_count === 0);

    const curProducts =
      drawer.querySelector('[data-location="cart-drawer"] [data-products]') ||
      drawer.querySelector('[data-products]');

    if (cart.item_count === 0) {
      if (curProducts) curProducts.innerHTML = '';
      await refreshDrawerFooter();
      await refreshHeaderCartIcon();

      // Re-apply after update
      updateKlarnaVisibility(cart.total_price, drawer);
      applySufioEuVisibility(drawer, cart.item_count);

      document.dispatchEvent(new CustomEvent('cart:updated'));
      return;
    }

    // Pull main cart section and replace products HTML
    const mainCartHTML = await fetchSectionHTML(MAIN_CART_SECTION_ID);
    const doc = new DOMParser().parseFromString(mainCartHTML, 'text/html');

    const newProducts = doc.querySelector('[data-location="page"] [data-products]');
    if (newProducts && curProducts) {
      curProducts.innerHTML = newProducts.innerHTML;
    } else {
      console.warn('Products container not found.', {
        newProducts: !!newProducts,
        curProducts: !!curProducts,
      });
    }

    await refreshDrawerFooter();

    // Re-apply after footer replacement
    updateKlarnaVisibility(cart.total_price, drawer);
    applySufioEuVisibility(drawer, cart.item_count);

    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  // ---------- REMOVE (delegated) ----------
  async function onRemoveClick(e) {
    const el = e.target.closest('.js-cart-remove');
    if (!el) return;

    // Only intercept inside drawer
    if (!el.closest(DRAWER_SELECTOR)) return;

    e.preventDefault();

    const key = el.getAttribute('data-key');
    if (!key) return;

    if ('disabled' in el) el.disabled = true;
    el.setAttribute('aria-busy', 'true');

    try {
      const updatedCart = await cartChange(key, 0);
      await refreshDrawerFromMainCart(updatedCart);
    } catch (err) {
      console.error(err);
    } finally {
      if ('disabled' in el) el.disabled = false;
      el.removeAttribute('aria-busy');
    }
  }

  // ---------- QUANTITY (delegated) ----------
  function getLineKeyFromEl(el) {
    const withKey = el.closest('[data-key]');
    return withKey?.getAttribute('data-key') || null;
  }

  function getQtyInputFromLine(line) {
    return (
      line.querySelector('input[name="updates[]"]') ||
      line.querySelector('input[data-quantity-input]') ||
      line.querySelector('input.js-qty__num') ||
      line.querySelector('input[type="number"]')
    );
  }

  async function updateQtyByDelta(targetEl, delta) {
    const drawer = targetEl.closest(DRAWER_SELECTOR);
    if (!drawer) return;

    const line =
      targetEl.closest('[data-key]') ||
      targetEl.closest('[data-line-item]') ||
      targetEl.closest('li') ||
      targetEl.closest('.cart__item');

    if (!line) return;

    const key = getLineKeyFromEl(line) || targetEl.getAttribute('data-key');
    if (!key) return;

    const input = getQtyInputFromLine(line);
    const cur = Math.max(0, parseInt(input?.value || '0', 10) || 0);
    const next = Math.max(0, cur + delta);

    if (input) input.value = String(next);

    const updatedCart = await cartChange(key, next);
    await refreshDrawerFromMainCart(updatedCart);
  }

  let qtyDebounceTimer = null;

  async function updateQtyFromInput(inputEl) {
    const drawer = inputEl.closest(DRAWER_SELECTOR);
    if (!drawer) return;

    const line =
      inputEl.closest('[data-key]') ||
      inputEl.closest('[data-line-item]') ||
      inputEl.closest('li') ||
      inputEl.closest('.cart__item');

    if (!line) return;

    const key = getLineKeyFromEl(line) || inputEl.getAttribute('data-key');
    if (!key) return;

    const next = Math.max(0, parseInt(inputEl.value || '0', 10) || 0);

    const updatedCart = await cartChange(key, next);
    await refreshDrawerFromMainCart(updatedCart);
  }

  function onQtyClick(e) {
    const drawer = e.target.closest(DRAWER_SELECTOR);
    if (!drawer) return;

    const plus =
      e.target.closest('[data-qty-plus]') ||
      e.target.closest('[data-quantity-plus]') ||
      e.target.closest('.js-qty__adjust--plus') ||
      e.target.closest('[aria-label="Increase quantity"]');

    const minus =
      e.target.closest('[data-qty-minus]') ||
      e.target.closest('[data-quantity-minus]') ||
      e.target.closest('.js-qty__adjust--minus') ||
      e.target.closest('[aria-label="Decrease quantity"]');

    if (!plus && !minus) return;

    e.preventDefault();
    updateQtyByDelta(plus || minus, plus ? +1 : -1).catch(console.error);
  }

  function onQtyChange(e) {
    const drawer = e.target.closest(DRAWER_SELECTOR);
    if (!drawer) return;

    const input = e.target.closest(
      'input[name="updates[]"], input[data-quantity-input], input.js-qty__num, input[type="number"]'
    );
    if (!input) return;

    clearTimeout(qtyDebounceTimer);
    qtyDebounceTimer = setTimeout(() => {
      updateQtyFromInput(input).catch(console.error);
    }, 250);
  }

  // ---------- REBUILD AFTER AJAX ADD-TO-CART ----------
  // Ensures totals are correct when items are added via configurator or theme AJAX.
  let rebuildTimer = null;

  function scheduleDrawerRebuild() {
    if (!getDrawer()) return;

    clearTimeout(rebuildTimer);
    rebuildTimer = setTimeout(() => {
      refreshDrawerFromMainCart(null).catch(console.error);
    }, 60);
  }

  document.addEventListener('ajaxProduct:added', scheduleDrawerRebuild, true);
  document.addEventListener('cart:build', scheduleDrawerRebuild, true);
  document.addEventListener('cart:open', scheduleDrawerRebuild, true);

  // Delegated listeners survive DOM updates
  document.addEventListener('click', onRemoveClick, true);
  document.addEventListener('click', onQtyClick, true);
  document.addEventListener('change', onQtyChange, true);
  document.addEventListener('click', onCartNoteToggleClick, true);
  document.addEventListener('input', onCartNoteInput, true);
  document.addEventListener('change', onCartNoteChange, true);

  // Re-sync on global cart updates
  document.addEventListener(
    'cart:updated',
    async () => {
      try {
        const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
        const cart = await cartRes.json();
        const drawer = getDrawer() || document;

        updateKlarnaVisibility(cart.total_price, drawer);
        applySufioEuVisibility(drawer, cart.item_count);
      } catch (e) {
        console.error(e);
      }
    },
    true
  );
})();

// ---------- DOM READY BINDINGS ----------
document.addEventListener('DOMContentLoaded', function () {
  // Apply discount
  document.addEventListener('click', function (e) {
    if (e.target.closest('#ApplyDiscountBtn')) {
      e.preventDefault();

      const codeInput = document.getElementById('CartDiscountCode');
      const msg = document.getElementById('DiscountMessage');
      const code = codeInput?.value?.trim() || '';

      if (msg) {
        msg.textContent = '';
        msg.className = 'discount-message';
      }

      if (!code) {
        if (msg) {
          msg.textContent = 'Please enter a discount code.';
          msg.classList.add('error');
        }
        return;
      }

      applyDiscount(code);
    }
  });

  // Clear discount message when typing
  const discountInput = document.getElementById('CartDiscountCode');
  if (discountInput) {
    discountInput.addEventListener('input', () => {
      const msg = document.getElementById('DiscountMessage');
      if (!msg) return;
      msg.textContent = '';
      msg.className = 'discount-message';
    });
  }

  // Toggle discount form
  const enable = document.querySelector('.cart-discount__form-enable');
  if (enable) {
    enable.addEventListener('click', () => {
      const containerForm = document.querySelector('.cart-discount__form');
      containerForm && containerForm.classList.toggle('active');
    });
  }

  // Apply Sufio EU visibility on first load (will hide unless customer EU except ES)
  applySufioEuVisibility(document);

  // Sufio VAT toggles (guarded)
  document.addEventListener('click', function (e) {
    const link = e.target.closest('.sufio-vat-form.sufio-vat-cart-form .sufio-vat-link');
    if (link) {
      // Allow opening only if customer EU except ES
      if (!isCustomerEUExceptES()) return;

      link.closest('.sufio-vat-form.sufio-vat-cart-form')?.classList.add('active');
      return;
    }

    const cancel = e.target.closest('.sufio-vat-form.sufio-vat-cart-form .sufio-vat-cancel-button');
    if (cancel) {
      cancel.closest('.sufio-vat-form.sufio-vat-cart-form')?.classList.remove('active');
    }
  });
});
